export class DTOTarif {
    'number_of_units': number;
    'tags': string[] = [];
    'tarif_id': string;
    'tarif_name': string;
    'total_price': number;
    'unit_price': number;
}
